import { useCallback, useEffect, useState } from 'react'

export type Theme = 'light' | 'dark'

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>('light')
  useEffect(() => {
    try {
      const t = localStorage.getItem('theme')
      setThemeState(t === 'dark' ? 'dark' : 'light')
    } catch {}
  }, [])
  const setTheme = useCallback((t: Theme) => {
    setThemeState(t)
    try {
      localStorage.setItem('theme', t)
    } catch {}
    document.documentElement.classList.toggle('dark', t === 'dark')
  }, [])
  const toggle = useCallback(() => setTheme(theme === 'dark' ? 'light' : 'dark'), [theme, setTheme])
  return { theme, setTheme, toggle }
}
